import api from 'api';

const url = 'api/events/:id/tickets/friend';

export default {
    search: (eventId, phone, has_ticket, cancelCallback) => api.get({path:url.replace(':id', eventId), params:{phone, has_ticket}, cancelCallback})
}